import React from "react";
import { Flex, ImagePicker, Button, Toast } from "antd-mobile";
import "./SunmitEnterMsg.scss";
import GoBack from "../../components/GoBack";
import { getItem } from "../../util/util";
import http from "../../util/api.js";
import { userInfo } from "os";
// 提交入职信息resid
const personInfo = 617651844877;
class SunmitEnterMsg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      photoLInk: [],
      IDlink: [],
      bankLink: [],
      recordSet: {
        ID: "",
        photoLInk: "",
        IDlink: "",
        bankLink: "",
        REC_ID: ""
      },
      result: "",
      personinfo: {}
    };
  }

  componentDidMount() {
    // let userData = JSON.parse(getItem('userInfo')).data
    // this.state.recordSet.ID = userData.UserCode
    this.getPersoninfo();
    let REC_ID = JSON.parse(localStorage.userInfo).UserInfo.REC_ID;
    console.log("userinfo", JSON.parse(localStorage.userInfo));
    this.setState({ recordSet: { REC_ID } });
    // this.state.recordSet.ID = data;
    // this.state.photoLInk = [{
    //     url: this.state.personinfo.photoLInk,
    //     id: '2121',
    // }]
  }

  // 点击提交，触发方法
  handleSunmit = async () => {
    // 判空
    if (
      !this.state.photoLInk.length ||
      !this.state.IDlink.length ||
      !this.state.bankLink.length
    ) {
      return Toast.fail("请上传完整的信息", 1);
    } else {
      // 修改接口
      let res;
      const resid = personInfo;
      let data = [
        {
          ...this.state.personinfo,
          photoLInk: this.state.photoLInk[0].url,
          IDlink: this.state.IDlink[0].url,
          bankLink: this.state.bankLink[0].url,
          C3_617652005557: "Y"
        }
      ];
      try {
        res = await http().modifyRecords({
          resid,
          data
        });
        console.log("res", res);
        Toast.loading("Loading...", 1);
        this.props.history.push("/submitOk");
      } catch (error) {
        console.log(error);
        // alert("提交失败"+ error);
      }
    }
  };

  // 图片上传
  onChange = (files, type, index, column) => {
    console.log(type, files);
    if (type === "remove") {
      this.setState({
        [column]: []
      });
    }
    if (type === "add" && files.length >= 1) {
      Toast.loading("上传中...", 0);
      const type = files[0].file.type.split("/");
      this.uploadFile(
        files[0].file,
        `http://kingofdinner.realsun.me:1201/api/AliyunOss/PutOneImageObject?bucketname=nutritiontower&srctype=${
          type[1]
        }`,
        "cloud"
      ).then(
        result => {
          this.setState({
            [column]: [{ url: result }],
            personInfo: { ...this.state.personinfo, [column]: result }
          });
          Toast.hide();
        },
        err => {
          //图片上传异常！
          Toast.fail(err.message);
        }
      );
    }
  };

  /**
   * 上传文件
   * @param {file} file 文件
   * @param {string} url 上传的地址
   * @param {string} mode 上传的模式：
   *'local' 本地；'cloud' 云对象存储
   */
  uploadFile = (file, url, mode) => {
    return new Promise((resolve, reject) => {
      let fd = new FormData();
      fd.append("file", file, file.name);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", url);
      xhr.onload = () => {
        const data = JSON.parse(xhr.response);
        if (xhr.status === 200 && (data.error === 0 || data.error === "0")) {
          let imgUrl;
          if (mode === "local") {
            imgUrl = data.httpfilename;
          } else if (mode === "cloud") {
            imgUrl = data.data;
          }
          resolve(imgUrl);
        } else {
          reject(data);
        }
      };
      xhr.send(fd);
    });
  };

  // 信息提交获取入提交入职信息表信息
  getPersoninfo = async () => {
    try {
      let res = await http().getTable({
        resid: personInfo
      });
      let { data } = res;
      if (data.data.length) {
        let photoLInk = data.data[0].photoLInk
            ? [{ url: data.data[0].photoLInk, id: 123 }]
            : [],
          IDlink = data.data[0].IDlink
            ? [{ url: data.data[0].IDlink, id: 123 }]
            : [],
          bankLink = data.data[0].bankLink
            ? [{ url: data.data[0].bankLink, id: 123 }]
            : [];
        console.log(photoLInk, IDlink, bankLink);
        this.setState({
          personinfo: data.data[0],
          photoLInk,
          IDlink,
          bankLink
        });
        // Toast.hide();
      } else {
      }
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  render() {
    let { photoLInk, IDlink, bankLink } = this.state;

    return (
      <div className="body">
        <GoBack
          goBack={() => {
            this.props.history.goBack();
          }}
        />
        <Flex className="body_mid" style={{ marginTop: "6%" }}>
          <Flex.Item className="body_personalImgTitle">员工正面照片</Flex.Item>
        </Flex>
        <hr
          style={{
            margin: "0 auto",
            width: "90%",
            height: "1px",
            border: "none",
            backgroundColor: "#f6f6f6"
          }}
        />
        <Flex className="body_mid" style={{ height: "23%" }}>
          <Flex.Item className="body_personalImg">
            <ImagePicker
              files={photoLInk}
              onChange={(files, type, index) =>
                this.onChange(files, type, index, "photoLInk")
              }
              onImageClick={(index, fs) => console.log(index, fs)}
              selectable={photoLInk.length < 1}
              accept="image/*"
            />
          </Flex.Item>
        </Flex>
        <Flex className="body_mid" style={{ marginTop: "6%" }}>
          <Flex.Item className="body_personalImgTitle">身份证复印件</Flex.Item>
        </Flex>
        <hr
          style={{
            margin: "0 auto",
            width: "90%",
            height: "1px",
            border: "none",
            backgroundColor: "#f6f6f6"
          }}
        />
        <Flex className="body_mid" style={{ height: "23%" }}>
          <Flex.Item className="body_personalImg">
            <ImagePicker
              files={IDlink}
              onChange={(files, type, index) =>
                this.onChange(files, type, index, "IDlink")
              }
              onImageClick={(index, fs) => console.log(index, fs)}
              selectable={IDlink.length < 1}
              accept="image/*"
            />
          </Flex.Item>
        </Flex>
        <Flex className="body_mid" style={{ marginTop: "6%" }}>
          <Flex.Item className="body_personalImgTitle">
            银行卡正面照片
          </Flex.Item>
        </Flex>
        <hr
          style={{
            margin: "0 auto",
            width: "90%",
            height: "1px",
            border: "none",
            backgroundColor: "#f6f6f6"
          }}
        />
        <Flex className="body_mid" style={{ height: "23%" }}>
          <Flex.Item className="body_personalImg">
            <ImagePicker
              files={bankLink}
              onChange={(files, type, index) =>
                this.onChange(files, type, index, "bankLink")
              }
              onImageClick={(index, fs) => console.log(index, fs)}
              selectable={bankLink.length < 1}
              accept="image/*"
            />
          </Flex.Item>
        </Flex>
        <Button
          type="primary"
          style={{
            marginTop: "6%",
            margin: "0 auto",
            width: "90%",
            marginBottom: "1rem"
          }}
          // onClick={() => {
          //     this.props.history.push("/submitOk");
          // }}
          onClick={this.handleSunmit}
        >
          提交
        </Button>
      </div>
    );
  }
}

export default SunmitEnterMsg;
